(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout,
            changeExpiredPassword: changeExpiredPassword
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                tenant: credentials.tenant,
                rememberMe: credentials.rememberMe,
                reCaptcha: credentials.reCaptcha
            };
            return $http.post('api/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function changeExpiredPassword (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                tenant: credentials.tenant,
                newPassword: credentials.newPassword
            };
            return $http.post('api/account/update_password', data);
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            $http.post('api/logout').then(function(response) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
            });
        }
    }
})();
